import { RouteType } from "../../../types/RouteType";

const PdfManagementRoute: RouteType = {
  name: "PDF Management",
  path: "/pdf/manage",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./PdfManagementHeader"),
      title: "PDF Management",
      color: "primary",
      enableBackButton: false,
      enableRefreshButton: true,
    },
    body: {
      component: () => import("./PdfManagementBody"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  dialogs: [
    {
      name: "PdfUpload",
      component: () => import("./PdfUploadDialog"),
      title: "Upload PDF Document",
      cancelButton: true,
      height: 500,
    },
  ],
  beforeEnter: async ({ rootStore }) => {
    // const { storeRegistry } = rootStore;

    // Load PDF documents
    const pdfManagementStore = (rootStore as any).pdfManagementStore;
    await pdfManagementStore.loadDocuments();

    return true;
  },

  requiresAuth: true,
  requiresAdmin: false,
};

export default PdfManagementRoute;
